<template>
  <div class="loading-wrapper">
    <div class="loading">
      <img width="24" height="24" src="./loading.gif">
      <p class="desc">{{title}}</p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: '正在载入...'
    }
  }
}
</script>
<style lang="stylus" scoped rel="stylesheet/stylus">
  @import "~common/stylus/variable"
  .loading-wrapper{
    z-index 999
    position fixed
    top 50%
    left: 50%
    -webkit-transform: translate(-50%, -50%)
    -moz-transform: translate(-50%, -50%)
    -ms-transform: translate(-50%, -50%)
    -o-transform: translate(-50%, -50%)
    transform: translate(-50%, -50%)
    width: size(180)
    height: size(180)
    text-align: center
    background-color: rgba(0, 0, 0, .5)
    padding-bottom: 0 !important
    -webkit-border-radius: 5px
    -moz-border-radius: 5px
    border-radius: 5px
    .loading{
      width: 100%
      position absolute
      top 50%
      left: 50%
      -webkit-transform: translate(-50%, -50%)
      -moz-transform: translate(-50%, -50%)
      -ms-transform: translate(-50%, -50%)
      -o-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      .desc{
        margin-top: 5px;
        font-size: size(25)
        color: #fff
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/loading/loading.vue